// extracted by mini-css-extract-plugin
export default {"deleteBtn":"AnnouncementModal_deleteBtn__XizQG","errorMessage":"AnnouncementModal_errorMessage__hDrjA","overfowX":"AnnouncementModal_overfowX__f-WKp"};